<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title" id="fm-7"><a id="page_xxxi"><em>Chronology</em></a></h1><a id="page_xxxi">
<table>
<tbody>
<tr>
<td class="td1"><p class="t-left"><span class="smallcaps">B.C.E.</span></p></td>
<td><p class="t-left"> </p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">538-332</p></td>
<td><p class="t-left">Palestine ruled by the Persians</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">before 525</p></td>
<td><p class="t-left">Jewish Temple erected at Elephantine in Egypt</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">516/515</p></td>
<td><p class="t-left">Jerusalem Temple rebuilt (traditional date)</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">458-445</p></td>
<td><p class="t-left">Careers of Ezra and Nehemiah in Jerusalem</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">332-323</p></td>
<td><p class="t-left">Conquests of Alexander the Great</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">322-301</p></td>
<td><p class="t-left">Wars of the Diadochi</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">301-198</p></td>
<td><p class="t-left">Palestine ruled by the Ptolemies</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">259-258</p></td>
<td><p class="t-left">Zenon, secretary to a finance minister of Ptolemy II, visits Palestine</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">ca. 250</p></td>
<td><p class="t-left">Translation of Torah into Greek</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">222-187</p></td>
<td><p class="t-left">Antiochus III rules the Seleucid Empire</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">198-142</p></td>
<td><p class="t-left">Palestine ruled by the Seleucids</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">190</p></td>
<td><p class="t-left">Battle of Magnesia: Antiochus III defeated by Rome</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">ca. 180</p></td>
<td><p class="t-left">Hyrcanus ben Joseph of the Tobiad family builds a palatial estate at <span class="f1">ʿ</span>Araq el-Emir in Transjordan</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">177-164</p></td>
<td><p class="t-left">Antiochus IV Epiphanes rules Seleucid Empire</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">175</p></td>
<td><p class="t-left">High Priest Onias III deposed by Antiochus IV and replaced by Jason, who establishes a gymnasium in Jerusalem</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">172</p></td>
<td><p class="t-left">Menelaus outbids Jason and is appointed high priest</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">170</p></td>
<td><p class="t-left">Onias III killed by Menelaus</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">169</p></td>
<td><p class="t-left">Antiochus IV’s first Egyptian campaign; plunder of the Jerusalem Temple</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">168</p></td>
<td><p class="t-left">Antiochus IV’s second Egyptian campaign (aborted); founding of the citadel in Jerusalem</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">167</p></td>
<td><p class="t-left">Desecration of the Jerusalem Temple and persecution of Judeans: beginning of the Maccabean Revolt</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">164</p></td>
<td><p class="t-left">Rededication of the Temple; death of Antiochus IV</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">162</p></td>
<td><p class="t-left">Menelaus executed; Alcimus appointed high priest</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">161</p></td>
<td><p class="t-left">Judas defeats Nicanor and makes treaty with Rome</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">160</p></td>
<td><p class="t-left">Battle of Elasa; Judas killed; Jonathan assumes leadership</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">ca. 160</p></td>
<td><p class="t-left">Onias IV builds temple at Heliopolis in Egypt</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">159</p></td>
<td><p class="t-left">Death of Alcimus</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">159-152</p></td>
<td><p class="t-left">Jewish high priesthood vacant</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">157</p></td>
<td><p class="t-left">Treaty between Jonathan and Bacchides; Syrians withdraw from Palestine</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">152</p></td>
<td><p class="t-left">Jonathan appointed high priest by Alexander Balas</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">142</p></td>
<td><p class="t-left">Death of Jonathan and accession of Simon</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">141</p></td>
<td><p class="t-left">Conquest of the Jerusalem citadel</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">140</p></td>
<td><p class="t-left">Simon confirmed as high priest, commander, and ethnarch</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">139</p></td>
<td><p class="t-left">Expulsion of Jews from Rome</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">134</p></td>
<td><p class="t-left">Death of Simon and accession of John Hyrcanus; Antiochus VII invades and besieges Jerusalem; John Hyrcanus comes to terms with Antiochus VII; Judea temporarily under Seleucid domination</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">129/128</p></td>
<td><p class="t-left">Antiochus VII dies; Judea is <em>de facto</em> independent; Hyrcanus campaigns in Transjordan</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">126-104</p></td>
<td><p class="t-left">Hasmonean expansion into Samaria, Idumea, and Galilee</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">112/111</p></td>
<td><p class="t-left">Samaritan temple on Mt. Gerizim destroyed by John Hyrcanus</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">104-103</p></td>
<td><p class="t-left">Aristobulus I high priest and king</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">103-76</p></td>
<td><p class="t-left">Alexander Jannaeus high priest and king</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">76-67</p></td>
<td><p class="t-left">Shelamzion Alexandra rules Judea as queen</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">67-66</p></td>
<td><p class="t-left">Hasmonean civil war breaks out; Hyrcanus II abdicates to Aristobulus II</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left"><a id="page_xxxii">65</a></p></td>
<td><p class="t-left">Hyrcanus and Aretas the Nabatean besiege Aristobulus; Romans halt siege</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">64</p></td>
<td><p class="t-left">Pompey annexes Syria: end of Seleucid rule</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">63</p></td>
<td><p class="t-left">Pompey captures Jerusalem: end of Hasmonean rule</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">58-49</p></td>
<td><p class="t-left">First Roman Triumvirate (Pompey, Crassus, Julius Caesar)</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">49-45</p></td>
<td><p class="t-left">Roman civil war between Julius Caesar and the <em>optimates</em> (conservative republicans), initially led by Pompey</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">48-47</p></td>
<td><p class="t-left">Antipater enlists Jewish support for Julius Caesar in Alexandria</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">47</p></td>
<td><p class="t-left">Phasael and Herod appointed <em>stratēgoi</em> in Galilee and Judea, respectively</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">44</p></td>
<td><p class="t-left">Assassination of Julius Caesar</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">44-31</p></td>
<td><p class="t-left">Second Roman Triumvirate (Marc Antony, Lepidus, Octavian)</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">42</p></td>
<td><p class="t-left">Phasael and Herod appointed tetrarchs by Marc Antony</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">40</p></td>
<td><p class="t-left">Parthians and Mattathias Antigonus invade Judea and besiege Jerusalem; Herod proclaimed King of Judea by Roman Senate</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">37</p></td>
<td><p class="t-left">Herod defeats last Hasmonean ruler, Mattathias Antigonus, and captures Jerusalem</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">31</p></td>
<td><p class="t-left">Battle of Actium: Octavian defeats Marc Antony</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">30</p></td>
<td><p class="t-left">Roman conquest and annexation of Egypt</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">27</p></td>
<td><p class="t-left">Octavian given titles <em>Augustus</em> and <em>Princeps;</em> rules as <em>de facto</em> emperor until death in 14 <span class="smallcaps">C.E.</span></p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">4</p></td>
<td><p class="t-left">Herod the Great dies</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">4 <span class="smallcaps">B.C.E.</span>-6 <span class="smallcaps">C.E.</span></p></td>
<td><p class="t-left">Archelaus rules Judea, Idumea, and Samaria; Antipas rules Galilee and Perea; Herod Philip II rules area northwest of Galilee until 34 <span class="smallcaps">C.E.</span></p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">6</p></td>
<td><p class="t-left">Judas the Galilean and Zadok the Pharisee found the “fourth philosophy” and lead a revolt in protest of the Judean census</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">6-41</p></td>
<td><p class="t-left">Judea made a Roman province ruled by prefects</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">14-37</p></td>
<td><p class="t-left">Tiberius, emperor</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">26-36</p></td>
<td><p class="t-left">Pontius Pilate, prefect of Judea</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">27-30</p></td>
<td><p class="t-left">Public career of Jesus of Nazareth</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">34-64</p></td>
<td><p class="t-left">Missionary career of Saul of Tarsus (Paul)</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">37-41</p></td>
<td><p class="t-left">Gaius Caligula, emperor</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">38</p></td>
<td><p class="t-left">Anti-Jewish pogrom in Alexandria, Egypt</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">40</p></td>
<td><p class="t-left">Caligula orders a statue of himself to be installed in the Jerusalem Temple</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">41</p></td>
<td><p class="t-left">Edict of Claudius confirms rights of Jews in Alexandria but warns them not to strive for more than they have</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">41-44</p></td>
<td><p class="t-left">King Agrippa I rules most of Palestine</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">41-54</p></td>
<td><p class="t-left">Claudius, emperor; expels Jews from Rome</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">44-66</p></td>
<td><p class="t-left">Roman procurators govern most of Palestine</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">54-68</p></td>
<td><p class="t-left">Nero, emperor</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">60-66</p></td>
<td><p class="t-left">Roman procurators Festus, Albinus, and Florus deal with brigands and popular uprisings in Judea</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">62</p></td>
<td><p class="t-left">Roman governor Flaccus seizes Jewish Temple tax from Apamea, Adramyttium, Laodicea, and Pergamum in Asia Minor</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">64</p></td>
<td><p class="t-left">Fire in Rome Death of James (brother of Jesus), Paul, and Peter</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">66</p></td>
<td><p class="t-left">Anti-Jewish riots in Alexandria; Tiberius Julius Alexander enforces reprisals</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">66-70</p></td>
<td><p class="t-left">First Jewish Revolt against Rome</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">68-69</p></td>
<td><p class="t-left">Year of the four emperors (Galba, Otho, Vitellius, and Vespasian)</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">69-79</p></td>
<td><p class="t-left">Vespasian, emperor</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">70</p></td>
<td><p class="t-left">Jerusalem Temple destroyed by Romans; <em>fiscus Iudaicus</em> imposed on Jews in lieu of Temple tax</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">73/74</p></td>
<td><p class="t-left">Masada, the last refuge of Jewish rebels under Eleazar ben Ya<span class="f1">ʾ</span>ir, falls to Romans Oniad temple at Leontopolis in Egypt destroyed by Romans</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">79-81</p></td>
<td><p class="t-left">Titus, emperor</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">80-90</p></td>
<td><p class="t-left">Beginnings of rabbinic academy at Yavneh (Jamnia) House of Hillel gains ascendancy over the House of Shammai Yo<span class="f1">ḥ</span>anan ben Zakkai is the leading rabbinic sage in Palestine</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">81-96</p></td>
<td><p class="t-left">Domitian, emperor</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">90-115</p></td>
<td><p class="t-left">Gamaliel II is the leading rabbinic sage</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">96-98</p></td>
<td><p class="t-left">Nerva, emperor</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">98-117</p></td>
<td><p class="t-left">Trajan, emperor</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">100-135</p></td>
<td><p class="t-left">Ishmael ben Elisha and Akiba ben Joseph are the leading rabbinic sages</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">116-117</p></td>
<td><p class="t-left">Diaspora Jewish uprisings in Egypt, Cyprus, and Cyrene</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">117-138</p></td>
<td><p class="t-left">Hadrian, emperor</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">132-135</p></td>
<td><p class="t-left">Bar Kokhba Revolt</p></td>
</tr>
<tr>
<td class="td1"><p class="t-left">200</p></td>
<td><p class="t-left">Rabbi Judah the Patriarch edits the Mishnah</p></td>
</tr>
</tbody>
</table>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 012_Chronology.vue?3a3fe112